<template>
	<component :is="field.type == 'fieldset' ? 'fieldset' : 'div'" :aria-required="field.ariaRequired" v-bind:role="field.role ? field.role : null" v-bind:class="field.inline ? 'formgroup inline' : 'formgroup vertical'" :id="createToggleElementId(field.id)">
		<template v-if="field.type == 'fieldset'">
			<field-legend :id='field.id + "Label"' :text='field.label' :help='field.helper'></field-legend>
			<span v-if="field.additionalInfo" class="additional-info">{{ field.additionalInfo }}</span>
		</template>
		<span v-if="field.role == 'radiogroup'" class="form-error hidden js-form-error" aria-live="assertive" :id='field.id + "Error"'>{{field['mandatory-message']}}</span>
		<div v-bind:class="field.inline ? 'inputs-wrap-horizontal' : 'inputs-wrap'">
			<input-group v-if="field.type == 'input'" 
				:id="field.id" 
				:text="field.label"
				:prefix="field.prefix"
				:mandatory-message="field['mandatory-message']"
				:invalid-message="field['invalid-message']"
				:min-length="field['min-length']"
				:max-length="field['max-length']"
				:opt="{...field.options, additionalInfo: field.additionalInfo}">
			</input-group>
			<template v-else-if="field.options !== 'date'">
				<input-group v-bind:key="ind" v-for="(opt, ind) in field.options" :id="toId(opt + ' ' + field.id)"
				:text="opt" :opt="{type: 'radio', name: field.id, 'data-error-message': field.error, class: 'radio', additionalInfo: field.additionalInfo}"
				v-on:togreduce="reduceTog(opt, toId(opt + ' ' + field.id))" @updateUkResident="updateUkResident">
				</input-group>
				<div :class="nonUkError ? 'form-error-large js-form-error' : 'form-error-large hidden js-form-error'" aria-live="assertive" id="ukResidencyCodeError">
					<span class="form-error">You must be a UK resident to apply for this card</span>
				</div>
			</template>
			<template v-else>
				<span class="datetext">For example, 04 / 12 / 1995</span>
				<span :class="errors['birthDate'] ? 'form-error js-form-error' : 'form-error hidden js-form-error'" aria-live="assertive" id="birthDateError">{{ errors['birthDate'] }}</span>
				<div class="dateitems" id="dateItems">
					<input-group
						v-for="(date, index) in dateInputs"
							v-bind:key="toId(date)"
							:id="field.id + date"
							:text="date"
							:mandatory-message="field['mandatory-message']"
							:invalid-message="field['invalid-message']"
							:opt="{placeholder: null, class: index == 2 ? 'dateinps year' : 'dateinps',
							autocomplete: index == 0 ? 'bday-day' : index === 1 ? 'bday-month' : index === 2 ? 'bday-year' : 'no', type: 'number',
							additionalInfo: field.additionalInfo}"
							:is-date-item="true"
							@update-errors="updateErrors"> 
					</input-group>
				</div>
			</template>
		</div>
	</component>
</template>
<script>

/*eslint-disable */

import fieldLegend from './fieldLegend.vue'
import inputGroup from './inputGroup.vue'

export default {
	name: 'field',
	data: function() {
		return {
			dateInputs: ["Day", "Month", "Year"],
			reducedinp: false,
			errors: {},
			nonUkError: false
		}
	},
	components: {
		inputGroup,
		fieldLegend
	},
	props: {
		field: Object
	},
	methods: {
		updateErrors(errors) {
			this.errors = errors;
		},
		updateUkResident(bool) {
			this.nonUkError = bool;
		},
		toId: function(a) {
			var elemId = "";
			for (var i = 0; i < a.split(" ").length; i++) {
				if (i == 0) {
					elemId += a.split(" ")[i].charAt(0).toLowerCase();
				} else {
					elemId += a.split(" ")[i].charAt(0).toUpperCase();
				}
				elemId += a.split(" ")[i].slice(1);
			}
			return elemId;
		},
		checkClass: function(a, b, c) {
			if (a[0] == 'Yes' && a[1] == 'No' && a.length == 2) {
				return 'radio';
			} else if (b == 'title') {
				return 'radio';
			} else if (Number(parseInt(a[1]))) {
				if (c == 0) {
					return 'checknumb checknumbf';
				} else if ((c + 1) == a.length) {
					return 'checknumb checknumbl';
				} else {
					return 'checknumb'
				}
			} else {
				return 'radio';
			}
		},
		reduceTog: function(a, c) {
			let b;
			if(c.indexOf('CreditType') !== -1){
				b = 'balenceTransfer';
			} else if(c.indexOf('AdditionalIncomeIndicator') !== -1) {
				b= 'reducedinc'
			}
			if (!this.reducedinp) {
				this.reducedinp = getById(b);
			}
			if (a == "Yes") {
				if (!getById(b)) {
					var toaddafter = getById(c).parentElement.parentElement;
					toaddafter.parentElement.insertBefore(
						this.reducedinp, toaddafter.nextSibling
					);
				}
				getById(b).style.display = "block";
			}
			else {
				removeElem(getById(b));
			}
		},
		createToggleElementId: function(fieldId) {
			if(fieldId ==='creditAmount'){
				return 'balenceTransfer'
			}
			else if(fieldId === 'otherHouseholdIncome') {
				return 'reducedinc'
			}
			// else return false
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
fieldset.vertical[role='radiogroup'] .inputs-wrap {
	display: flex;
	flex-direction: column;
	gap: 1rem;
	padding-top: 0.125rem;
}
fieldset.vertical[role='radiogroup'] .inputs-wrap-horizontal,
fieldset.inline[role='radiogroup'] .inputs-wrap-horizontal {
	padding-top: 0.125rem;
}
#reducedinc {
	display: none;
}
#balenceTransfer {
	display: none;
}
fieldset .inputs-wrap-horizontal {
	display: flex;
	gap: 1.5rem;
}
legend {
	padding: 0px;
	font-size: 1.125em;
	font-weight: bold;
	line-height: 1.75rem;
	margin-bottom: 0.5rem;
	max-width: 100%;
}
.checkboxes {
	display: inline-block;
}
p {
	top: 0.5em;
	margin: 0px;
	color: #e51635;
}

@media screen and (max-width: 35.9375rem) {
    fieldset .inputs-wrap-horizontal {
		flex-direction: column;
		gap: 1rem;
	}
}
</style>
